<template>
    <div>
        <Breadcumb :title="category.name" :breadcumb-data="breadcumbData">
            <b-btn v-bind:to="'add/'" variant="primary"><i class="ion ion-md-add"></i>&nbsp; Nouveau sujet</b-btn>
        </Breadcumb>
        <b-card no-body class="mb-3 cardcontainer">
            <b-card-header class="d-none d-md-block">

            </b-card-header>
            
            <div v-for="(article, index) in category.articles" :key="article.title">
                <b-card-body class="py-3">
                    
                    <div class="row no-gutters align-items-center">
                        <div class="col">
                            <b-btn v-bind:to="'/echanges/article/' + article.id + '/'"  class="text-big font-weight-semibold" variant="primary">
                                {{article.title}}
                            </b-btn>
                            <div class="text-muted small mt-1">
                                Crée le {{article.date_created|formatDate}} &nbsp; par
                                {{article.author.firstname}} {{article.author.lastname}}
                            </div>
                        </div>
                    </div>
                
                </b-card-body>
                <hr class="m-0" v-if="index !== (category.articles.length - 1)">
            </div>
        </b-card>
    </div>
</template>

<script>
    import {GET_FORUMARTICLES_REQUEST} from "../_store/exchange/actiontypes";
    import Breadcumb from '../components/breadcumb'
    import { mapState } from 'vuex';

    export default {
        name: 'pages-forums-threads',
        components: { Breadcumb},
        computed: mapState({ category: state => state.exchange.category}),
        mounted() {
            this.$store.dispatch(GET_FORUMARTICLES_REQUEST, this.$route.params.id)
                .then(() => {
                    this.breadcumbData =  [
                        {text: this.$t('welcome'), href: '/dashboard/'},
                        {text: "Forum d'échange", href: '/echange/forum/'},
                        {text: this.category.name, active: true}
                    ]
                })
        },
        data() {
            return {
                breadcumbData: []
            }
        }
    }
</script>
